(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-aeat', {
                parent: 'entity',
                url: '/consortium-tributos-aeat?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosAeat'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat.html',
                    controller: 'ConsortiumTributosAeatController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-aeat.new', {
                parent: 'consortium-tributos-aeat',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-new.html',
                    controller: 'ConsortiumTributosAeatNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-aeat'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-aeat',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-aeat.edit', {
                parent: 'consortium-tributos-aeat',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosAeat'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-detail.html',
                        controller: 'ConsortiumTributosAeatDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-aeat'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosAeat', function($stateParams, ConsortiumTributosAeat) {
                        return ConsortiumTributosAeat.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-aeat',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
